module.exports = __webpack_public_path__ + "img/fileCopy.308da63f.svg";